import React, { useContext, useEffect, useState } from 'react';
import {
  ContentTableWrapper,
  TableLinksWrapper,
} from '../elements/TableOfContentElements';
import AppContext from '../context/index';

function getIds(items) {
  return items.reduce((acc, item) => {
    if (item.url) {
      // url has a # as first character, remove it to get the raw CSS-id
      acc.push(item.url.slice(1));
    }
    if (item.items) {
      acc.push(...getIds(item.items));
    }
    return acc;
  }, []);
}
function useActiveId(itemIds) {
  const [activeId, setActiveId] = useState(`test`);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: `0% 0% -80% 0%` }
    );
    itemIds.forEach((id) => {
      observer.observe(document.getElementById(id));
    });
    return () => {
      if (itemIds.length)
        itemIds.forEach((id) => {
          observer.unobserve(document.getElementById(id));
        });
    };
  }, [itemIds]);
  return activeId;
}
export const renderItems = (items, activeId, dark, level) => {
  return (
    <ul>
      {items.map((item) => {
        return (
          <li
            key={item.url}
            style={{
              padding: `${0.25 - 0.2 * level}rem 0`,
              paddingLeft: '0.75rem',
            }}
          >
            <TableLinksWrapper
              dark={dark}
              isActive={activeId === item?.url?.slice(1)}
            >
              <a style={{ fontSize: 16 - 2 * level }} href={item.url}>
                {item.title}
              </a>
            </TableLinksWrapper>
            {item.items && renderItems(item.items, activeId, dark, level + 1)}
          </li>
        );
      })}
    </ul>
  );
};
export const TableOfContents = (props) => {
  const idList = getIds(props.items);
  const activeId = useActiveId(idList);

  const { dark } = useContext(AppContext);

  return (
    <ContentTableWrapper dark={dark}>
      <summary
        style={{ textAlign: 'center', color: dark ? 'white' : '#061f2f' }}
      >
        Table of Contents
      </summary>
      {renderItems(props.items, activeId, dark, 0)}
    </ContentTableWrapper>
  );
};
